import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppContent from './AppContent';
import axios from 'axios';
import Loader from './components/Loader';
import Header from './components/Header';
import Footer from './components/Footer';
import BASE_URL from './config/config';
import ScrollToTop from './components/ScrollToTop';

const Routering = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [tokenInfo, setTokenInfo] = useState(null); // 👈 nuevo
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verificarToken = async () => {
      try {
        const token = localStorage.getItem('AuthToken');
        if (!token) {
          throw new Error('No se encontró token');
        }

        const response = await axios.get(`${BASE_URL}/autenticacion`, {
          headers: {
            Authorization: `${token}`,
          },
        });

        setAuthenticated(true);
        setUserRole(response.data.role);
        setTokenInfo(response.data); // 👈 guardamos toda la info que venga del backend
      } catch (error) {
        setAuthenticated(false);
        setUserRole(null);
        setTokenInfo(null); // 👈 limpiamos también
        localStorage.removeItem('AuthToken');
      } finally {
        setLoading(false);
      }
    };

    verificarToken();
  }, []);

  return (
    <Router>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ScrollToTop />
          <Header authenticated={authenticated} />
          <AppContent
            authenticated={authenticated}
            userRole={userRole}
            tokenInfo={tokenInfo} // 👈 ahora se lo pasamos
          />
          <Footer />
        </>
      )}
    </Router>
  );
};

export default Routering;
